import { Alert, Form, Modal, Upload } from 'antd'
import { InboxOutlined } from '@ant-design/icons'
import * as React from 'react'
import moment from 'moment'

import { IConfigurazioneService } from '../../services/ConfigurazioneService'
import { IRaccoltaDatiService } from '../../services/RaccoltaDatiService'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'

import { ContoCorrenteModel } from '../../models/ConfigurazioneModels'
import { RcCustomRequestOptions } from 'antd/lib/upload/interface'
import { FormInstance } from 'antd/lib/form'
import { TTModalProps } from '../shared/TTModalProps'

import { TTFormItem } from '../shared/TTFormItem'
import { TTSelect } from '../shared/TTSelect'
import { renderSelectModel } from '../shared/SelectOptionRenderUtils'
import { IApiService } from '../../services/shared/ApiService'
import { IYapilyService } from '../../services/YapilyService'

const { Dragger } = Upload

class ModalImportYapilyLookupState {
    
}

interface ModalImportYapilyLookupProps {
}

export class ModalImportYapilyLookup extends React.Component<TTModalProps & ModalImportYapilyLookupProps, ModalImportYapilyLookupState> {

    formRef = React.createRef<FormInstance>()

    service: IYapilyService
    confService: IConfigurazioneService
    apiService: IApiService

    constructor(props) {
        super(props)

        this.service = container.get(SERVICE_IDENTIFIER.YAPILY_SERVICE)
        this.confService = container.get(SERVICE_IDENTIFIER.CONFIGURAZIONE_SERVICE)

        this.apiService = container.get(SERVICE_IDENTIFIER.API_SERVICE);
        this.state = new ModalImportYapilyLookupState()
    }


    acceptedMimeTypes = () => {
        let list = [
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ]
        return list.join(",")
    }


    uploadImage = async (options: RcCustomRequestOptions) => {
        const { onSuccess, onError, file } = options

        // Non può andare in eccezione perchè finchè il campo è vuoto l'upload è disabilitato
        let resp = await this.service.ImportYapilyLookup(file)
        if (resp.IsValid === true) {
            onSuccess(resp, file)
            this.props.closeModal()
            this.props.do()
        } else {
            const error = new Error(resp.Notifies[0].Message)
            onError(error)
        }
    };

    renderUploadHint = () => {
        

        return (
            <p className="ant-upload-hint">
                Seleziona il conto corrente per abilitare il caricamento del file
            </p>
        )
    }

    downloadExapleFile = () => {
        this.apiService.downloadFile("/api/Utility/GetSampleFile");
    }

    closeModal = () => {
        this.props.closeModal()
    }

    render() {
        return (
            <Modal
                title="Importazione lookup"
                width={600}
                visible={this.props.visible}
                onCancel={this.closeModal}
                footer={null}>
                <Alert type="warning"
                    showIcon
                    message={`Import lookup`}
                    description={<div>
                        <span>Importando il file tutte verranno elimati tuti i valori attuali. </span>
                        <br />
                        <span>Per mantenerli esegio "Scarica lookup" e implementa il file che ti verrà generato</span>
                    </div>
                    }
                />
                <br />
                <Dragger
                    accept={this.acceptedMimeTypes()}
                    showUploadList={false}
                    customRequest={options => this.uploadImage(options)}
                    >
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Clicca o trascina il file in quest'area per caricarlo</p>
                    
                </Dragger>
            </Modal>
        )
    }
}